<template>
  <div class="container-fluid">
    <v-timer
      :seconds="internalSeconds"
    />
  </div>
</template>

<script>
import Timer from './Timer.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FeedbackView',
  components: {
    'v-timer': Timer,
  },
  props: {
    seconds: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      internalSeconds: this.seconds,
    };
  },

  mounted() {
    this.counter = setInterval(() => {
      this.internalSeconds -= 1;
      if (this.internalSeconds < -1) {
        clearInterval(this.counter);
      }
    }, 1000);
  },
});
</script>
